import Rails from "@rails/ujs"
import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["select", "from", "to", "search"];

  connect() {
    const userIds = this.readUserIds()
    userIds.forEach((id) => {
      const el = document.getElementById(`reservation_id_${id}`)
      if (el) el.checked = true
    })
    document.getElementById("checked_reservations_ids").value = userIds
  }

  disconnect() {
    this.submitForm()
  }

  selectDate(event) {
    const el = event.currentTarget;
    let today = new Date;
    switch (el.value) {
      case "1":
        this.setFromCalender(today);
        this.setToCalender(today);
        this.fromTarget.value = this.dateFormat(today);
        this.toTarget.value = this.dateFormat(today);
        break;
      case "2":
        today.setDate(today.getDate() - 1);
        this.setFromCalender(today);
        this.setToCalender(today);
        this.fromTarget.value = this.dateFormat(today);
        this.toTarget.value = this.dateFormat(today);
        break;
      case "3":
        today.setDate(today.getDate() + 1);
        this.setFromCalender(today);
        this.setToCalender(today);
        this.fromTarget.value = this.dateFormat(today);
        this.toTarget.value = this.dateFormat(today);
        break;
      case "4":
        today.setDate(today.getDate() - today.getDay());
        this.setFromCalender(today);
        this.fromTarget.value = this.dateFormat(today);
        today.setDate(today.getDate() + 6 - today.getDay());
        this.setToCalender(today);
        this.toTarget.value = this.dateFormat(today);
        break;
      case "5":
        today.setDate(today.getDate() - 7 - today.getDay());
        this.setFromCalender(today);
        this.fromTarget.value = this.dateFormat(today);
        today.setDate(today.getDate() - 7 + 6 - today.getDay());
        this.setToCalender(today);
        this.toTarget.value = this.dateFormat(today);
        break;
      case "6":
        today.setDate(today.getDate() + 7 - today.getDay());
        this.setFromCalender(today);
        this.fromTarget.value = this.dateFormat(today);
        today.setDate(today.getDate() + 7 + 6 - today.getDay());
        this.setToCalender(today);
        this.toTarget.value = this.dateFormat(today);
        break;
      default:
        this.setFromCalender(null);
        this.setToCalender(null);
        this.fromTarget.value = null;
        this.toTarget.value = null;
    }
  }

  dateFormat(date) {
    if (date != null) {
      return date.getFullYear() + "-" + (date.getMonth() + 1).toString().padStart(2, "0") + "-" + date.getDate().toString().padStart(2, "0")
    } else {
      return "";
    }
  }
  setFromCalender(date) {
    const from_calendar = this.fromTarget.bulmaCalendar;
    from_calendar.startDate = this.dateFormat(date);
    from_calendar.save();
  }
  setToCalender(date) {
    const to_calendar = this.toTarget.bulmaCalendar;
    to_calendar.startDate = this.dateFormat(date);
    to_calendar.save();
  }

  clearDate(event) {
    event.preventDefault();
    this.selectTarget.selectedIndex = 0;
    this.fromTarget.value = null;
    this.toTarget.value = null;
    const cbs = document.querySelectorAll(".datetimepicker-clear-button");
    cbs.forEach(function (cb) {
      cb.click();
    });
  }

  readUserIds() {
    const userIds = localStorage.getItem('reservationIds')
    return userIds ? userIds.split(",") : []
  }

  setUserIds(ids) {
    const userIds = ids.join(",")
    localStorage.setItem('reservationIds', userIds)
    this.setCheckedUserIds(userIds)
  }

  setCheckedUserIds(ids) {
    document.getElementById("checked_reservations_ids").value = ids
  }

  addIdToUserIds(id) {
    const lastUserIds = this.readUserIds()
    const foundIndex = lastUserIds.indexOf(id)
    if (foundIndex < 0) {
      lastUserIds.push(id)
      this.setUserIds(lastUserIds)
    }
  }

  removeIdFromUserIds(id) {
    const lastUserIds = this.readUserIds()
    const foundIndex = lastUserIds.indexOf(id)
    if (foundIndex > -1) {
      lastUserIds.splice(foundIndex, 1)
      this.setUserIds(lastUserIds)
    }
  }

  checkboxItem(event) {
    document.querySelector("[value='実行']").disabled = false
    const { value, checked } = event.target
    checked ? this.addIdToUserIds(value) : this.removeIdFromUserIds(value)
  }

  submitForm() {
    localStorage.removeItem('reservationIds')
    document.querySelectorAll('[name="reservation_id[]"]').forEach((node) => {
      node.checked = false
    })
  }

  enableSubmit(e) {
    document.querySelector("[value='実行']").disabled = false
  }

  orderChange(){
    this.searchTarget.submit();
  }
}
